import { NewProduct } from '@/types/product';

import { RequestService } from '../services/request.service';

/**
 * Получает запись о продаже товара
 * @param id UUID записи о продаже
 */
export async function getFishSale(id: string) {
	const request = RequestService.getInstance();

	const { data } = await request.get<NewProduct>(`/api_v1/sell-fish/${id}/`);

	return data;
}
